import React from "react";

export default function TequilaFrame5({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2000 2000"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>
            {
              ".cls-teq51{fill:#ffeb57}.cls-teq54{fill:#ebf0f2}.cls-teq56{fill:#f2dc41}.cls-teq58{fill:#f4e027}.cls-teq511{fill:#ffe652}.cls-teq512{fill:#d7dee2}.cls-teq513{fill:#c7ced1}.cls-teq514{fill:#ead015}.cls-teq515{fill:#eacf11}"
            }
          </style>
        </defs>
        <ellipse
          cx={1063.13}
          cy={121.54}
          rx={114.05}
          ry={37.58}
          style={{
            fill: "#7f6022",
          }}
        />
        <ellipse
          cx={1013.01}
          cy={121.54}
          rx={52.09}
          ry={15.36}
          style={{
            fill: "#8e6c30",
          }}
        />
        <path
          d="M1240.34 1855.54c-171.09 3.49-342.2 6.95-513.29 10.42-46.36.95-83.97-37.32-82.21-83.67 11.78-310.85 23.54-621.7 35.31-932.53 1.62-43.33 37.22-77.59 80.57-77.59h1.62c40.78 0 75.14-30.44 80.05-70.91l30.15-248.33 1.22-9.93 2.86-23.54.91-7.58 3.87-31.89c4.92-40.47 39.27-70.91 80.05-70.91h48.76c41.33 0 75.99 31.27 80.2 72.38l3.13 30.42.78 7.58 2.42 23.54 1.01 9.93 25.38 246.84c4.21 41.13 38.86 72.4 80.22 72.4s78.91 34.25 80.57 77.54c11.78 307.38 23.57 614.74 35.34 922.12 1.74 45.07-33.84 82.79-78.93 83.7Z"
          className="cls-teq512"
        />
        <path
          d="M1096.75 443a803.783 803.783 0 0 1-222.99 0c.95-7.85 1.91-15.69 2.86-23.54l.91-7.58h216.01l.78 7.58 2.42 23.54Z"
          className="cls-teq513"
        />
        <path
          d="M1228.83 872.33c-1.39-37.85-31.2-67.78-67.5-67.78-34.63 0-52.22-27.33-55.76-63.27l-11.94-121.22c-2.54-25.8-25.89-44.53-51.59-41.15-15.15 2-41.94 3.27-57.53 3.76-20.1.79-40.01-.36-59.69-3.04-25.39-3.46-48.6 14.88-51.56 40.33l-14.27 122.6c-4.12 35.38-32.9 61.98-67.05 61.98h-1.36c-36.31 0-66.12 29.95-67.5 67.81-9.86 271.69-19.71 543.37-29.57 815.06-1.47 40.51 30.03 73.95 68.87 73.13 143.32-3.04 286.63-6.07 429.95-9.11 37.77-.8 67.57-33.77 66.12-73.16l-29.61-805.95Z"
          className="cls-teq58"
        />
        <path
          d="M1067.38 423.13h-167c-32.86 0-61.1-20.08-67.32-47.88l-15.12-67.48c-7.17-32.01 17.11-62.94 54.24-69.19 31.65-5.32 68.61-9.11 109.83-8.98 41.36.13 78.35 4.17 109.9 9.69 35.37 6.18 58.97 35.1 54.06 65.9l-10.67 66.92c-4.66 29.24-33.67 51.03-67.93 51.03Z"
          className="cls-teq512"
        />
        <path
          d="M1092.32 239.28a649.843 649.843 0 0 0-109.9-9.69c-41.22-.13-78.19 3.66-109.83 8.98-29.34 4.93-50.64 25.29-54.76 49.4 1.48 2.46 3.76 5.98 6.94 9.87 23.32 28.49 61.64 36.11 142.56 37.15 103.37 1.33 157.79 1.37 173.58-30.7 3.78-7.69 4.41-15.3 4.28-20.77-5.97-21.76-26.02-39.55-52.86-44.24Z"
          className="cls-teq513"
        />
        <path
          d="M1079.88 271c-1.17 14.17-12.03 25.63-26.12 27.5a572.105 572.105 0 0 1-82.97 4.91c-24.83-.34-47.7-2.27-68.27-5.03-13.69-1.84-24.38-12.73-26-26.45-4.86-41.35-9.73-82.7-14.59-124.04 28.12-6.94 64.51-13.2 107.13-13.82a476.31 476.31 0 0 1 120.96 13.82l-10.14 123.1Z"
          style={{
            fill: "#6b5015",
          }}
        />
        <path
          d="M969.06 134.07c-42.62.62-79.01 6.88-107.13 13.82l4.82 40.97c10.32 8.17 25.95 18.51 46.75 24.9 47.19 14.49 77.98-4.59 95.74 11.49 9.73 8.81 16.12 28.7 1.4 77.3 6.99 1.71 23.14-1.41 43.11-4.06 14.09-1.87 24.95-13.33 26.12-27.5l10.14-123.1a476.25 476.25 0 0 0-120.96-13.82Z"
          style={{
            fill: "#634811",
          }}
        />
        <ellipse
          cx={971.65}
          cy={1819.13}
          className="cls-teq513"
          rx={271.29}
          ry={20.54}
        />
        <ellipse
          cx={1270.22}
          cy={1201.53}
          className="cls-teq54"
          rx={14.25}
          ry={231.55}
          transform="rotate(-2.48 1270.93 1202.21)"
        />
        <ellipse
          cx={690.76}
          cy={1130.28}
          className="cls-teq54"
          rx={57.43}
          ry={14.61}
          transform="rotate(-87.13 690.816 1130.294)"
        />
        <path
          d="M1095.63 537.57c3.84 4.36 5.3 8.55 9.07 44.93 4.21 40.62 7.02 67.71 3.93 68.26-3.9.69-1.79-43.4-29.27-74.2-42.03-47.11-126.82-33.45-126.72-40.28.08-5.07 46.67-7.42 62.21-8.21 66.36-3.35 76.28 4.39 80.78 9.5ZM1028.67 415.35c0 5.97-93.55 2.7-140.65-3.21-6.39-.8-16.97-2.29-26.97-9.75-13.44-10.02-18.17-25.12-23.33-42.34-4.47-14.92-8.95-37.57-5.18-38.88 4.55-1.58 10.39 31.67 38.16 54.43 7.81 6.41 19.62 13.83 73.3 25.05 59.56 12.45 84.67 11.6 84.67 14.69Z"
          className="cls-teq54"
        />
        <ellipse
          cx={982.8}
          cy={589}
          className="cls-teq51"
          rx={92.1}
          ry={16.91}
        />
        <ellipse
          cx={780.38}
          cy={1023.39}
          className="cls-teq51"
          rx={25.69}
          ry={190.08}
        />
        <ellipse
          cx={895.38}
          cy={740.05}
          className="cls-teq51"
          rx={12.85}
          ry={89.29}
        />
        <ellipse
          cx={961.51}
          cy={1713.54}
          className="cls-teq514"
          rx={190.08}
          ry={19.38}
        />
        <ellipse
          cx={1179.23}
          cy={1234.41}
          className="cls-teq514"
          rx={32.6}
          ry={367.19}
        />
        <rect
          width={701.23}
          height={701.23}
          x={630.9}
          y={917.11}
          rx={49.42}
          ry={49.42}
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M1282.71 1625.52h-602.4c-31.21 0-56.6-25.39-56.6-56.6v-602.4c0-31.21 25.39-56.6 56.6-56.6h602.4c31.21 0 56.6 25.39 56.6 56.6v602.4c0 31.21-25.39 56.6-56.6 56.6Zm-602.4-701.23c-23.29 0-42.23 18.94-42.23 42.23v602.4c0 23.29 18.94 42.23 42.23 42.23h602.4c23.29 0 42.23-18.94 42.23-42.23v-602.4c0-23.29-18.94-42.23-42.23-42.23h-602.4Z"
          className="cls-teq58"
        />
        <path
          d="M1417.93 1471.4c19.23 17.63 38.47 35.25 57.7 52.88-62.62 52.44-76.52 132.32-46.57 177.54 36.41 54.97 148.38 74.93 228.79 2.8 21.47 20.31 42.93 40.62 64.4 60.94-14.04 14-39.11 34.55-75.62 47.87-75.32 27.49-163.91 11.53-225.37-47.88-84.04-81.23-85.52-212.93-3.33-294.15Z"
          className="cls-teq515"
        />
        <path
          d="M1433.27 1486.23c42.12 37.84 84.24 75.67 126.37 113.51 13.22 12.87 26.45 25.74 39.67 38.61l106.92 111.72c-72.14 70.43-192.37 69.07-266.94-3-72.69-70.26-74.46-184.7-6.02-260.84Z"
          className="cls-teq58"
        />
        <path
          d="M1582.77 1650.25c6.2-2.62 14.14 6.81 49.12 41.31 40.27 39.71 51.33 48.47 48.68 59.39-2.38 9.78-14.1 14.48-34.16 22.52-21.46 8.6-37.21 14.92-48.93 8.24-7.66-4.37-10.85-12.72-15.94-72.49-4.29-50.37-3.11-57.14 1.23-58.97Z"
          className="cls-teq511"
        />
        <path
          d="M1582.78 1650.25c6.2-2.61 14.13 6.82 49.12 41.31 40.27 39.7 51.33 48.47 48.68 59.39-2.37 9.78-14.1 14.48-34.16 22.52-21.46 8.6-37.21 14.92-48.93 8.24-.95-.54-1.83-1.14-2.65-1.9 8.99-1.32 19.61-5.57 32.18-10.61 20.05-8.04 31.78-12.74 34.16-22.52 2.65-10.92-8.41-19.69-48.68-59.4-15.58-15.36-25.79-25.75-32.88-32.31.67-3 1.75-4.12 3.17-4.72Z"
          className="cls-teq515"
        />
        <path
          d="M1555.87 1648.14c6.43 2.43 5.47 14.41 6.36 62.3 1.02 55.12 2.84 68.78-6.95 74.53-8.76 5.16-20.73.38-41.2-7.78-21.91-8.74-37.98-15.15-41.78-27.81-2.48-8.28 1.18-16.25 40.34-61.19 33.01-37.87 38.73-41.76 43.23-40.05Z"
          className="cls-teq511"
        />
        <path
          d="M1549.68 1649.56c2.93-1.93 4.64-2.01 6.19-1.42 6.43 2.44 5.47 14.41 6.36 62.3 1.02 55.12 2.83 68.78-6.95 74.53-8.76 5.16-20.73.38-41.2-7.78-19.69-7.85-34.66-13.83-40.25-24.14 7.37 4.6 17.34 8.57 28.94 13.2 20.47 8.16 32.44 12.94 41.2 7.78 9.78-5.76 7.96-19.41 6.95-74.54-.48-25.51-.42-40.83-1.24-49.94Z"
          className="cls-teq515"
        />
        <path
          d="M1537.65 1606.63c2.61-6.09-7.13-13.74-42.81-47.55-41.07-38.92-50.16-49.63-61.3-46.91-9.98 2.43-14.66 13.94-22.67 33.63-8.57 21.07-14.85 36.53-7.89 47.91 4.55 7.44 13.13 10.46 74.34 14.78 51.59 3.64 58.5 2.41 60.33-1.85Z"
          className="cls-teq511"
        />
        <path
          d="M1432.32 1512.51c-3.04 5.47-5.98 12.68-9.59 21.55-8.56 21.07-14.85 36.53-7.89 47.91 4.55 7.43 13.13 10.46 74.34 14.78 23.38 1.65 37.58 2.3 46.29 2.12 2.52 3.42 3.06 5.68 2.17 7.75-1.83 4.26-8.73 5.49-60.33 1.85-61.21-4.32-69.79-7.34-74.34-14.78-6.97-11.38-.67-26.84 7.89-47.91 7.68-18.87 12.29-30.23 21.45-33.27Z"
          className="cls-teq515"
        />
        <path
          d="M1540.1 1632.9c-2.56-6.25-14.8-5.19-63.81-5.53-56.41-.39-70.4-2.01-76.18 7.61-5.18 8.62-.16 20.26 8.42 40.18 9.18 21.31 15.92 36.95 28.91 40.52 8.49 2.34 16.61-1.33 62.16-40.1 38.39-32.67 42.3-38.31 40.5-42.69Z"
          className="cls-teq511"
        />
        <path
          d="M1400.25 1634.75c1.7 6.42 5.06 14.21 9.28 24 9.18 21.31 15.92 36.95 28.91 40.53 8.49 2.33 16.61-1.33 62.16-40.1 17.44-14.84 27.75-24.1 33.66-30.2 3.36.8 5.05 2.02 5.83 3.93 1.79 4.38-2.12 10.01-40.51 42.69-45.55 38.76-53.67 42.43-62.16 40.1-12.99-3.57-19.73-19.21-28.91-40.53-8.58-19.91-13.59-31.56-8.41-40.17.05-.08.1-.16.15-.23Z"
          className="cls-teq515"
        />
        <path
          d="M303.41 1553.77c-39.74 80.43-32.91 176.83 17.56 252.2-1.86 4.83-4.04 12.21-4.15 21.33-.07 5.6-.28 22.09 7.55 28.22 9.39 7.35 31.58.79 51.82-19.59 7.96-.03 145.88-2.95 218.47-121.8 49.87-81.66 49.13-185.67-1.78-268.4 16.27-29.61 5.91-59.63-8.89-65.86-13.97-5.88-40.13 5.97-52.01 34.17-97.11-.56-186.12 53.85-228.57 139.74Z"
          className="cls-teq58"
        />
        <path
          d="M303.41 1553.77c42.44-85.89 131.46-140.3 228.57-139.74 7.33-17.4 20.1-28.57 32.08-33.19.2.51.49 1.28.77 2.23 3.2 10.63-.55 20.91-2.27 24.22-6.18 11.88-24.75 7.83-55 16.12-22.09 6.06-33.13 9.08-39.22 16.98-22.28 28.88 48.59 86.93 31.15 127.33-18.48 42.81-113.05 12.36-163.12 77.29-15.23 19.75-21.26 41.74-23.85 51.18-12.59 45.93-2.24 84.98 3.35 101.84-45.78-74.11-50.82-166.62-12.46-244.25Z"
          style={{
            fill: "#ffea55",
          }}
        />
        <path
          d="M357.27 1831.38c3.62-15.51-34.07-27.44-33.77-42.03.43-20.69 76.71-19.26 141.94-53.53 80.49-42.29 147.59-140.76 128.94-210.66-13.02-48.78-68.23-85.27-58.85-97.42 5.3-6.88 23.76 3.75 35.98-6.35 10.81-8.94 9.66-28.23 7.1-42.88.77.07 1.73.22 2.8.48.9.22 1.76.5 2.58.85 14.8 6.23 25.16 36.25 8.89 65.86 50.9 82.74 51.64 186.75 1.78 268.4-72.58 118.86-210.51 121.78-218.47 121.8-20.24 20.38-42.44 26.94-51.82 19.59-6.94-5.43-7.56-18.99-7.57-25.9 7.58 10.46 18.98 15.22 28.4 12.38.55-.17 10.35-3.26 12.06-10.6Z"
          className="cls-teq514"
        />
        <path
          d="M1432.5 1581.69c-14.35 14.01-28.7 28.02-43.05 42.04 49.39 38.77 62.02 99.81 40.11 135.28-26.64 43.13-112.19 61.19-175.73 7.73l-48 48.39c11.13 10.42 30.9 25.6 59.27 34.94 58.54 19.28 126.23 4.86 172-42.28 62.59-64.46 60.53-165.69-4.61-226.1Z"
          className="cls-teq58"
        />
        <path
          d="M1421.08 1593.46c-31.44 30.1-62.89 60.2-94.33 90.3-9.85 10.21-19.69 20.42-29.54 30.64-26.48 29.48-52.96 58.96-79.43 88.45 57.14 52.36 149.5 48.39 205.03-8.81 54.14-55.76 52.71-143.74-1.73-200.57Z"
          className="cls-teq51"
        />
        <path
          d="M1310.2 1723.13c-4.83-1.86-10.7 5.58-36.74 32.94-29.98 31.49-38.26 38.5-35.95 46.82 2.06 7.46 11.19 10.78 26.79 16.47 16.7 6.09 28.96 10.55 37.8 5.14 5.78-3.54 8.03-10.04 10.48-56.09 2.07-38.81 1-43.98-2.38-45.28Z"
          className="cls-teq56"
        />
        <path
          d="M1310.2 1723.13c-4.83-1.86-10.69 5.58-36.73 32.94-29.98 31.49-38.26 38.5-35.96 46.82 2.06 7.46 11.19 10.78 26.8 16.47 16.7 6.09 28.95 10.56 37.8 5.14.71-.44 1.38-.92 1.99-1.52-6.94-.79-15.2-3.8-24.99-7.37-15.6-5.69-24.73-9.02-26.79-16.47-2.3-8.32 5.98-15.33 35.95-46.82 11.59-12.18 19.19-20.41 24.48-25.63-.59-2.29-1.44-3.13-2.55-3.55Z"
          className="cls-teq58"
        />
        <path
          d="M1330.82 1720.85c-4.88 2.03-3.85 11.2-3.37 48.02.56 42.38-.5 52.92 7.15 57.1 6.86 3.75 15.94-.21 31.47-6.98 16.62-7.25 28.82-12.57 31.42-22.38 1.71-6.42-1.3-12.46-32.49-46.03-26.28-28.3-30.78-31.14-34.19-29.72Z"
          className="cls-teq56"
        />
        <path
          d="M1335.62 1721.79c-2.3-1.42-3.61-1.43-4.79-.94-4.88 2.03-3.85 11.21-3.37 48.02.56 42.38-.5 52.92 7.16 57.1 6.86 3.75 15.94-.21 31.46-6.98 14.93-6.51 26.3-11.47 30.34-19.53-5.55 3.72-13.11 7.01-21.91 10.85-15.53 6.77-24.61 10.73-31.47 6.98-7.66-4.19-6.59-14.72-7.15-57.1-.26-19.61-.67-31.38-.26-38.41Z"
          className="cls-teq58"
        />
        <path
          d="M1343.82 1688.51c-2.15-4.62 5.14-10.73 31.73-37.58 30.61-30.9 37.33-39.35 45.96-37.54 7.73 1.62 11.61 10.35 18.23 25.29 7.1 15.98 12.3 27.71 7.23 36.62-3.32 5.83-9.84 8.36-56.76 13.17-39.55 4.05-44.89 3.28-46.4.05Z"
          className="cls-teq56"
        />
        <path
          d="M1422.45 1613.63c2.47 4.13 4.9 9.6 7.89 16.33 7.09 15.98 12.3 27.71 7.23 36.62-3.31 5.82-9.83 8.35-56.76 13.17-17.92 1.84-28.82 2.68-35.52 2.75-1.85 2.69-2.21 4.44-1.48 6.01 1.51 3.23 6.85 4.01 46.4-.05 46.93-4.81 53.45-7.34 56.76-13.17 5.08-8.91-.14-20.64-7.23-36.62-6.36-14.31-10.18-22.93-17.29-25.04Z"
          className="cls-teq58"
        />
        <path
          d="M1342.57 1708.76c1.81-4.87 11.25-4.35 48.89-5.8 43.34-1.67 54.05-3.26 58.72 3.99 4.19 6.5.62 15.57-5.49 31.08-6.54 16.6-11.33 28.78-21.23 31.84-6.47 2-12.8-.62-48.74-29.29-30.29-24.17-33.43-28.4-32.16-31.81Z"
          className="cls-teq56"
        />
        <path
          d="M1450.07 1706.77c-1.15 4.97-3.54 11.04-6.55 18.67-6.53 16.6-11.33 28.78-21.23 31.84-6.47 2-12.8-.62-48.74-29.3-13.76-10.98-21.91-17.84-26.6-22.39-2.57.69-3.83 1.67-4.38 3.16-1.27 3.41 1.87 7.64 32.17 31.81 35.94 28.68 42.27 31.29 48.74 29.29 9.89-3.06 14.69-15.24 21.23-31.84 6.11-15.51 9.68-24.58 5.49-31.07l-.12-.18Z"
          className="cls-teq58"
        />
        {children}
      </g>
    </svg>
  );
}
